var url= 'sale4all.co.il';
// var url= '192.168.1.24:8000';
var api_port = ""
export const SystemApp={

  base_url: `http://api.${url}/`,
  base_url_api: `http://api.${url}`,
  web_socket: `ws://${url}/ws/`

  // base_url: `http://${url}`,
  // base_url_api: `http://${url}${api_port}`,
  // web_socket: `ws://${url}:${api_port}/ws/`
}
